'use client';
import Link from 'next/link';
import React, { useState } from 'react';
import './allDropdown.scss';
import { GetAllCategoriesResult } from '@/sanity.types';
import Button from '../button/button';

export default function AllDropdown({
  categoryList,
  activeCategory,
}: {
  activeCategory?: string | null;
  categoryList: GetAllCategoriesResult;
}) {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <div className="resource-type">
      <Button
        onClick={toggleVisibility}
        aria-haspopup="true"
        aria-expanded={isVisible}
        aria-controls="resource-dropdown"
        className="resource-type-btn"
      >
        {activeCategory ? activeCategory : 'All'}
      </Button>
      <div
        className={`resourceCateDropdown ${isVisible ? 'show' : 'hide'}`}
        id="resource-dropdown"
        role="menu"
        aria-labelledby="resource-dropdown"
      >
        {categoryList?.map((category) => {
          return (
            <Link
              key={category?._id}
              role="menuitem"
              href={
                category.title == 'All'
                  ? '/resources'
                  : `/resources/category/${category?.slug?.current}`
              }
            >
              {category?.title}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
